

import React from 'react';
import { AddonsConsumer } from '../../../../Addons';
import CaptionAddonViewComponent from '../components/CaptionAddonView';

function CaptionAddonView(props) {
  return (
    <AddonsConsumer>
      {({ actions: { getCaptions } }) =>
      <CaptionAddonViewComponent
        getCaptions={getCaptions}
        {...props} />}


    </AddonsConsumer>);

}

export default CaptionAddonView;